import React from 'react';
import './index.scss';

const TopBanner = ({ categoryName }) => (
    <div className="category-top-banner">
        <h2 className="banner-title">
            {categoryName}
        </h2>
    </div>
);

export default TopBanner;
